import type { TrackedEvent } from './events'

export const SESSION_IDLE_MS = 30 * 60 * 1000
export const SESSION_MAX_MS = 24 * 60 * 60 * 1000

// UUIDv7 embeds the client clock at session creation in its first 48 bits.
// Compare with the event's client timestamp, not server receipt time: queued
// events and visitors with skewed clocks must keep their original attribution.
const UUID_V7 = /^[0-9a-f]{8}-[0-9a-f]{4}-7[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i

export const enforceSessionLifetime = (event: TrackedEvent): TrackedEvent | null => {
  const sessionId = event.properties.$session_id
  if (typeof sessionId !== 'string' || !UUID_V7.test(sessionId)) {
    return event
  }
  const startedAt = Number.parseInt(sessionId.slice(0, 13).replace('-', ''), 16)
  if (event.timestamp - startedAt < SESSION_MAX_MS) {
    return event
  }
  // Older bundles can stay open for days after a deploy. Stop those events
  // extending sessions too, without losing affiliate actions or diagnostics.
  if (event.event === '$pageleave' || event.event === 'time-on-page') {
    return null
  }
  const properties = { ...event.properties }
  delete properties.$session_id
  delete properties.$window_id
  return { ...event, properties }
}
